import type { ReactNode } from "react";
import { EmptyState } from "../../components/ui";
import { useAuth } from "../auth/AuthProvider";
import {
  isPublicModuleEnabled,
  useMunicipalModuleVisibility,
} from "./useModuleVisibility";

export function AuthenticatedModuleGate({
  moduleCode,
  children,
}: {
  moduleCode: string;
  children: ReactNode;
}) {
  const { user } = useAuth();
  const { data: visibility = {} } = useMunicipalModuleVisibility(
    user?.municipalityId ?? "",
  );
  if (!isPublicModuleEnabled(visibility, moduleCode)) {
    return (
      <div className="app-page">
        <EmptyState
          title="Módulo temporalmente oculto"
          description="Esta sección se encuentra temporalmente fuera de servicio."
        />
      </div>
    );
  }
  return children;
}
